module.exports = {
	"id": "AG",
	"name": "Antigua and Barbuda",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.032136,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.02678,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.016068,
			"28": 0.010712,
			"29": 0.037492,
			"30": 0.032136,
			"31": 0.278512,
			"32": 0.016068,
			"33": 0.010712,
			"34": 0.010712,
			"35": 0.021424,
			"36": 0.069628,
			"37": 0.182104,
			"38": 0.037492,
			"39": 0.032136,
			"40": 0.016068,
			"41": 0.058916,
			"42": 0.101764,
			"43": 0.123188,
			"44": 0.032136,
			"45": 0.042848,
			"46": 0.155324,
			"47": 0.05356,
			"48": 0.074984,
			"49": 1.360424,
			"50": 0.10712,
			"51": 0.551668,
			"52": 0.326716,
			"53": 20.920536,
			"54": 5.43634,
			"55": 0.123188,
			"56": 0.02678,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": 0.005356,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.02678,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.005356,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.037492,
			"22": 0.005356,
			"23": 0.005356,
			"24": 0.010712,
			"25": 0.005356,
			"26": 0.010712,
			"27": null,
			"28": 0.005356,
			"29": 0.021424,
			"30": null,
			"31": 0.021424,
			"32": null,
			"33": null,
			"34": 0.021424,
			"35": null,
			"36": null,
			"37": 0.058916,
			"38": 0.010712,
			"39": 0.032136,
			"40": 0.042848,
			"41": 0.032136,
			"42": null,
			"43": 0.058916,
			"44": 0.005356,
			"45": 0.048204,
			"46": 0.058916,
			"47": 0.246376,
			"48": 0.310648,
			"49": 4.108052,
			"50": 0.037492,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.042848,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.091052,
			"28": 0.05356,
			"29": 0.176748,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.037492,
			"34": null,
			"35": 0.005356,
			"36": null,
			"37": 0.364208,
			"38": 0.037492,
			"39": null,
			"40": 0.342784,
			"41": 0.037492,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.021424,
			"12.1": 0.048204
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.085696,
			"6": null,
			"7": 0.021424,
			"8": 0.198172,
			"9": 0.2678,
			"10": 1.09798,
			"3.1": null,
			"3.2": null,
			"5.1": 0.096408,
			"6.1": 0.037492,
			"7.1": 0.005356,
			"9.1": 0.835536
		},
		"ios_saf": {
			"8": 0,
			"10": 5.27736202331,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.142218799958,
			"8.1-8.4": 0.262743206703,
			"9.0-9.2": 0.125345383014,
			"9.3": 1.91232058701
		},
		"android": {
			"3": 0,
			"4": 0.126699276486,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0158374095607,
			"4.1": 0.457022390181,
			"4.2-4.3": 1.14255597545,
			"4.4": 2.61996003876,
			"4.4.3-4.4.4": 2.64258490956
		},
		"ie": {
			"6": null,
			"7": 0.010712,
			"8": 0.251732,
			"9": 0.2678,
			"10": 0.203528,
			"11": 3.310008,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0618239770125,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00171733269479
		},
		"edge": {
			"12": 0.203528,
			"13": 0.921232,
			"14": 1.799616
		},
		"ie_mob": {
			"10": 0.144714647887,
			"11": 0.589195352113
		},
		"bb": {
			"7": 0.1370275,
			"10": null
		},
		"samsung": {
			"0": 4.984085
		},
		"and_uc": {
			"0": 0.766425
		},
		"op_mini": {
			"0": 0.832943690293
		},
		"and_chr": {
			"0": 29.703389
		},
		"and_ff": {
			"0": 0.21367
		}
	},
	"total": 98.5908055
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/AG.json
 ** module id = 458
 ** module chunks = 0
 **/